import type { ReactNode } from "react";
import {
  InnerCrudContext,
  type InnerCrudContextValue,
} from "./useInnerCrudContext";

export interface InnerCrudContextProviderProps {
  value: InnerCrudContextValue;
  children: ReactNode;
}

export function InnerCrudContextProvider({
  value,
  children,
}: InnerCrudContextProviderProps) {
  return (
    <InnerCrudContext.Provider value={value}>
      {children}
    </InnerCrudContext.Provider>
  );
}

export { InnerCrudContext };
